import { styled } from '@mui/material'
import { messageTypeByFileType, useFileObjectUrl } from '$func/file'
import { BackButton, SecondaryButton } from '$common/buttons'
import { CreateStoryFooter } from '$comp/modals/create-story/components/footer'
import { t } from '$i18n'
import { CreateStoryHeader } from './header'

export function SubmitFile({
  file,
  onBack,
  handleSubmit,
}: {
  file: File
  onBack: () => void
  handleSubmit: () => void
}) {
  const type = messageTypeByFileType(file.type)
  const url = useFileObjectUrl(file)
  return (
    <Root>
      <CreateStoryHeader>
        <BackButton onClick={onBack} color="neutral000" />
      </CreateStoryHeader>

      {type === 'IMAGE' ? (
        <img
          style={{
            margin: 'auto',
            width: '100%',
            height: '100%',
            position: 'absolute',
            objectFit: 'contain',
          }}
          src={url}
          alt=""
        />
      ) : type === 'VIDEO' ? (
        <video
          style={{
            margin: 'auto',
            width: '100%',
            height: '100%',
            position: 'absolute',
          }}
          controls
          src={url}
        />
      ) : null}
      <CreateStoryFooter>
        <SecondaryButton
          onClick={handleSubmit}
          fullWidth
          text={t('story.createStoryModal.submit')}
        />
      </CreateStoryFooter>
    </Root>
  )
}

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.neutral1000};
`
